const history = require("history");

export default history.createBrowserHistory();